
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23 9.45h-2.1C20.63 5.1 18.52 3 14.46 3H1a1 1 0 00-.7.29A1 1 0 000 4v12.52a1 1 0 001 1h2.17a2.92 2.92 0 00-.1.73 2.74 2.74 0 105.47 0 2.92 2.92 0 00-.1-.73h7.12a2.92 2.92 0 00-.1.73 2.74 2.74 0 105.47 0 2.92 2.92 0 00-.1-.73H23a1 1 0 001-1v-6.07a1 1 0 00-1-1zM2 5h11.46v4.26H2zm3.8 14a.74.74 0 11.74-.74.74.74 0 01-.74.74zm12.4 0a.74.74 0 11.73-.74.74.74 0 01-.73.74zm3.8-3.48H2v-4.26h12.46a1 1 0 001-1V5c1.91.22 3.47 1.31 3.47 5.41a1 1 0 001 1H22z"}})])
          )
        }
      }
    